import { Gender } from "./gender";

export const nameWithGenderLabels = {
  [Gender.Male]: "accountOwner.male",
  [Gender.Female]: "accountOwner.female",
  [Gender.Other]: "accountOwner.other",
  [Gender.None]: "accountOwner.none",
};
